import PropTypes from 'prop-types';

export default {
  classes: PropTypes.object,
  dispatch: PropTypes.func
};
